export function useCalendarAPI() {
  const { errors, request } = useRequestV2();

  async function getCalendarEvents(requestBody: GetCalendarEventsRequestDTO) {
    const url = 'V3/Planning/GetCalendarEvents';

    const response = await request<CalendarEventsListContainerDTO>(url, {
      method: 'POST',
      body: requestBody
    });

    return response;
  }

  async function deleteCalendarEvent(requestBody: DeleteCalendarEventRequestDTO ) {
    const url = 'V3/Planning/Delete';

    const response = await request(url, {
      method: 'POST',
      body: requestBody
    });

    return response;
  }

  async function saveCalendarEvent(event: UpsertCalendarEvent) {
    const method = event.ID === undefined ? 'CreateIonic' : 'UpdateIonic';
    const url = `V3/Planning/${method}`;

    const response = await request<CalendarEventsListContainerDTO>(url, {
      method: 'POST',
      body: event
    });

    return response;
  }

  async function saveManyCalendarEvent(event: CreateManyCalendarEventsRequestDTO) {
    const url = 'V3/Planning/IonicCreateMany';

    const response = await request<CalendarEventsListContainerDTO>(url, {
      method: 'POST',
      body: event
    });

    return response;
  }

  async function getEventCategories() {
    const url = 'V3/Planning/GetAllCalendarEventCategories';
    const response = await request<CalendarEventCategoryDTO[]>(url, {
      method: 'GET'
    });

    return response;
  }

  async function getResourceGroups() {
    const url = 'V3/Planning/GetResourceGroups';
    const response = await request<ResourceGroupDTO[]>(url, {
      method: 'GET'
    });

    return response;
  }

  async function checkAvailability(requestBody: CheckAvailabilityRequestDTO) {
    const url = 'V3/Planning/CheckAvailability';

    const response = await request<CheckAvailabilityResponseDTO>(url, {
      method: 'POST',
      body: requestBody
    });

    return response;
  }

  async function GetById(id: number) {
    const url = `V3/Planning/GetByID/${id}`;

    const response = await request<CalendarEventListItemDTO>(url, {
      method: 'GET'
    });

    return response;
  }

  return {
    errors,
    saveManyCalendarEvent,
    checkAvailability,
    getCalendarEvents,
    saveCalendarEvent,
    getEventCategories,
    deleteCalendarEvent,
    getResourceGroups,
    GetById
  };
}
